import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { reportService } from '../../services/reportService';

const initialState = {
  loading: false,
  reportData: null,
  error: null,
};

export const fetchReportData = createAsyncThunk(
  "reports/fetchReportData",
  async ({
    report_type,
    start_date,
    end_date,
    trend_year,
    technology_field,
    current_working_sector,
    full_name,
    registered_from,
    registered_to,
    identity_number,
    filter_status,
    board_from,
    board_to,
    certificate_type,
  }, thunkAPI) => {
    try {
      const response = await reportService.getReportDetails({
        report_type,
        start_date,
        end_date,
        trend_year,
        technology_field,
        current_working_sector,
        full_name,
        registered_from,
        registered_to,
        identity_number,
        filter_status,
        board_from,
        board_to,
        certificate_type,
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const generateExcelSheet = createAsyncThunk(
  "reports/generateExcelSheet",
  async ({ report_type, start_date, end_date, trend_year, technology_field, current_working_sector, full_name, registered_from, registered_to, identity_number, search, board_approval_from, board_approval_to, filter_status, certificate_type, payment_from, payment_to, }, thunkAPI) => {
    try {
      const response = await reportService.generateExcelSheet({ report_type, start_date, end_date, trend_year, technology_field, current_working_sector, full_name, registered_from, registered_to, identity_number, search, board_approval_from, board_approval_to, filter_status, certificate_type, payment_from, payment_to });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const reportSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    logoutreport: (state, action) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReportData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReportData.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardData = action.payload;
      })
      .addCase(fetchReportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(generateExcelSheet.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateExcelSheet.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardData = action.payload;
      })
      .addCase(generateExcelSheet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const {
  logoutreport,
} = reportSlice.actions;
export default reportSlice.reducer;